import { CallAPI } from "../../apiManager/ApiCall";
import {
  getPackageURL,
  getVerifyUserPurchaseURL,
  getTransactionsURL,
  getVerifyUserAddedManuallyPurchaseURL
} from "../../apiManager/APIConfig";

export const GetTransactionCall = async (lang, user_id) => {
  try {
    const response = await CallAPI({
      url: `${getTransactionsURL}?lang=${lang}&user_id=${user_id}`,
      method: "GET",
    });
    if (!response?.status) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};
export const DeleteTransactionCall = async (body) => {
  try {
    console.log("pippo body", body);

    const response = await CallAPI({
      url: `${getTransactionsURL}`,
      method: "DELETE",
      body,
    });
    if (!response?.status) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};
export const AddTransactionCall = async (body) => {
  try {
    const response = await CallAPI({
      url: `${getTransactionsURL}`,
      method: "POST",
      body,
    });
    if (!response?.status) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};
export const GetPackagesCall = async (lang = "en", type = "ios") => {
  try {
    const response = await CallAPI({
      url: `${getPackageURL}?lang=${lang}&type=${type}`,
      method: "GET",
    });
    if (!response?.status) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};
export const GetVerifyUserPurchaseCall = async (platform, token, user_id) => {
  try {
    const response = await CallAPI({
      url: `${getVerifyUserPurchaseURL}`,
      method: "POST",
      body: { platform, user_id },
      token,
    });
    if (!response?.status) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};



export const GetVerifyUserAddedManuallyPurchaseCall = async (platform, token, user_id) => {
  try {
    const response = await CallAPI({
      url: `${getVerifyUserAddedManuallyPurchaseURL}`,
      method: "GET",
      body: { platform, user_id },
      token,
    });
    if (!response?.status) {
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};
